var _path, _ellipse, _circle, _circle2, _ellipse2, _ellipse3, _path2, _path3, _circle3, _circle4, _circle5, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.1861 119.112H17.5586C15.3495 119.112 13.5586 117.322 13.5586 115.112V37C13.5586 34.7909 15.3495 33 17.5586 33H133.345C135.554 33 137.345 34.7909 137.345 37V76.9532",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 74.5544,
    cy: 122.701,
    rx: 73.5544,
    ry: 3.58802,
    fill: "#053668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2689,
    cy: 74.7104,
    r: 4.03652,
    fill: "#053668"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.6342,
    cy: 74.7104,
    r: 4.03652,
    fill: "#053668"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 55.2695,
    cy: 82.7835,
    rx: 4.93353,
    ry: 2.24251,
    fill: "#053668"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 95.6347,
    cy: 82.7835,
    rx: 4.93353,
    ry: 2.24251,
    fill: "#053668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7299 88.6133C80.8329 85.9223 78.4233 84.1283 75.4509 84.1283C72.4785 84.1283 70.0689 85.9223 69.1719 88.6133",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5586 36C13.5586 34.3431 14.9017 33 16.5586 33H134.345C136.002 33 137.345 34.3431 137.345 36V41.073H13.5586V36Z",
    fill: "#053668"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9405,
    cy: 36.5889,
    r: 1.79401,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3214,
    cy: 36.587,
    r: 1.79401,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7042,
    cy: 36.5889,
    r: 1.79401,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.712 88.4228C155.221 98.9319 155.221 115.97 144.712 126.48C134.203 136.989 117.164 136.989 106.655 126.48C96.1462 115.97 96.1462 98.9319 106.655 88.4228C117.164 77.9138 134.203 77.9138 144.712 88.4228Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.712 126.48C155.221 115.97 155.221 98.9319 144.712 88.4228C134.203 77.9138 117.164 77.9138 106.655 88.4228C96.1462 98.9319 96.1462 115.97 106.655 126.48C117.164 136.989 134.203 136.989 144.712 126.48ZM144.712 126.48L156.182 137.949",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111 122H136C138.209 122 140 120.209 140 118V93",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.ac3fd8ed8cf3da3703f0b6e0c0da113b.svg";
export { ForwardRef as ReactComponent };